import { ValidateField, ExponentialToDecimal, FieldHasValue } from 'helpers/Validation';

export const AsLeftTestTableDeviationEu2Formula = (formData) => FieldHasValue(formData.F300SwitchSetpoint) && FieldHasValue(formData.F184AltTestEquipmentIndication)
    ? ExponentialToDecimal(Math.abs(ValidateField(formData.F300SwitchSetpoint) - ValidateField(formData.F184AltTestEquipmentIndication))) : '';
